// extracted by mini-css-extract-plugin
var _1 = "SearchView-module__aiAnswer--gO3_Q";
var _2 = "SearchView-module__animatedBackground--MPh3o";
var _3 = "SearchView-module__container--zQNtQ";
var _4 = "SearchView-module__header--IVAjJ";
var _5 = "SearchView-module__headerContainer--SSOYA";
var _6 = "SearchView-module__headerTitle--qNyLe";
var _7 = "SearchView-module__headerTitleContainer--QyUQq";
var _8 = "SearchView-module__keywords--JLwKW";
var _9 = "SearchView-module__loading--fhbic";
var _a = "SearchView-module__loadingHidden--tzrY5";
var _b = "SearchView-module__noKeywords--zQ6Kr";
var _c = "SearchView-module__results--RDsnC";
var _d = "SearchView-module__showSidebar--nzpTu";
var _e = "SearchView-module__title--Yp9jG";
var _f = "SearchView-module__verticalExtraContainer--kwoUB";
export { _1 as "aiAnswer", _2 as "animatedBackground", _3 as "container", _4 as "header", _5 as "headerContainer", _6 as "headerTitle", _7 as "headerTitleContainer", _8 as "keywords", _9 as "loading", _a as "loadingHidden", _b as "noKeywords", _c as "results", _d as "showSidebar", _e as "title", _f as "verticalExtraContainer" }
